import * as React from "react";
import { QueryRoute } from "bernie-core";
import { ESSAdapter, UitkTypeahead, TypeaheadToolbarVersion, TypeaheadRenderType } from "uitk-react-typeahead";
import { Layer } from "bernie-view";
import { DestinationFieldProps } from "../typings";
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { hotelConfig } from "src/stores/wizard/config";
import { useLocalization } from "@shared-ui/localization-context";

const DestinationTypeaheadDialog = (children: JSX.Element) => {
  return (
    <QueryRoute query={{ pwaDialog: "destination" }}>
      <Layer id="typeahead">{children}</Layer>
    </QueryRoute>
  );
};

export const DestinationField = (props: DestinationFieldProps) => {
  const typeaheadOnClickHandler = (renderType: string) => {
    if (renderType === TypeaheadRenderType.DIALOG) {
      props.openDialog();
    }
  };

  const typeaheadOnDismissHandler = (renderType: string) => {
    if (renderType === TypeaheadRenderType.DIALOG) {
      props.closeDialog(WizardDialogTrigger.TYPEAHEADCLOSE);
    }
  };

  const { formatText } = useLocalization();

  let features = "postal_code|multiregion_parent|ta_hierarchy";
  features = props.enableGoogleAdapter ? `${features}|google` : features;

  return (
    <UitkTypeahead
      adapter={
        new ESSAdapter({
          client: "HotelsLandingPage",
          dest: true,
          essLogger: props.essAnalyticsLogger,
          features,
          guid: props.guid,
          inputId: props.formFieldModel.formFieldStid,
          lob: "HOTELS",
          locale: props.locale,
          maxResults: hotelConfig.location.destination.essAdapterConfig.maxResults,
          regionType: 2047,
          siteId: parseInt(props.siteId, 10),
          personalize: true,
          domain: "/",
          enableEgta: props.enableEgta,
        })
      }
      onClick={typeaheadOnClickHandler}
      onDismiss={typeaheadOnDismissHandler}
      onUpdate={props.updateDestinationField}
      renderDialog={DestinationTypeaheadDialog}
      hasClearButton={false}
      allowExactMatch={true}
      icon="place"
      onMountCB={props.setDestinationRef}
      name={props.formFieldModel.formFieldName}
      stid={props.formFieldModel.formFieldStid}
      label={formatText(props.formFieldModel.formFieldLabel)}
      toolbarVersion={TypeaheadToolbarVersion.V1}
      invalid={props.invalid}
      value={props.destination || ""}
      typeaheadPlaceholder={formatText(props.formFieldModel.typeaheadPlaceholder!)}
      renderType={TypeaheadRenderType.DIALOG}
    />
  );
};
